"use client";

import { useEffect } from "react";
import { flushQueue, initYm } from "../ym";

type Props = {
  counterId: number;
  webvisor?: boolean;
  clickmap?: boolean;
  trackLinks?: boolean;
  accurateTrackBounce?: boolean;
};

const TAG_URL = "https://mc.yandex.ru/metrika/tag.js";

type YmFn = ((...args: unknown[]) => void) & { a?: unknown[][]; l?: number };
type WindowWithYm = typeof globalThis & { ym?: YmFn };

function installShim(w: WindowWithYm): void {
  if (typeof w.ym === "function") return;
  const shim: YmFn = (...args: unknown[]) => {
    shim.a = shim.a ?? [];
    shim.a.push(args);
  };
  shim.l = Date.now();
  w.ym = shim;
}

function appendTagScript(): void {
  if (document.querySelector(`script[src="${TAG_URL}"]`) !== null) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = TAG_URL;
  document.head.appendChild(s);
}

export function MetricaScript(props: Props): null {
  const {
    counterId,
    webvisor = false,
    clickmap = true,
    trackLinks = true,
    accurateTrackBounce = true,
  } = props;

  useEffect(() => {
    if (counterId === 0) return;
    if (typeof window === "undefined") return;

    const w = window as WindowWithYm;
    installShim(w);
    w.ym?.(counterId, "init", {
      webvisor,
      clickmap,
      trackLinks,
      accurateTrackBounce,
    });
    appendTagScript();
    initYm(counterId);
    flushQueue();
  }, [counterId, webvisor, clickmap, trackLinks, accurateTrackBounce]);

  return null;
}
